
let  placeholder =  {
    /* placeholder */
    enterKeyword: 'Key Words',
    enterUsername: 'Enter Username',
    enterPass: 'Enter Password',
    enterNewPass: 'Enter New Password',
    enterPassAgain: 'Enter Password Again',
    enterEmail: 'Enter Email',
    selectGroup: 'Select User Group',
    selectSuperior: 'Enter Superior',
    enterName: 'Enter Name',
    enterPhone: 'Enter Phone',
    enterUserGroupCnName: 'Enter User Group Name',
    enterUserGroupEnName: 'Enter User Group English Name',
    enterUserGroupCnDesc: 'Enter User Group Description',
    enterUserGroupEnDesc: 'Enter User Group English Description',
    changeGroup: 'Select Group',
    /* message 提示 */
    addSuccess: 'Add Success',
    editSuccess: 'Modify Success',
    adduserSuccess: 'Add User Success',
    edituserSuccess: 'Modify Userinfo Success',
    adduserGroupSuccess: 'Add User Group Success',
    adduserGroupError: 'Add User Group Failed',
    editGroupAuthSuccess: 'Modify User Group permissions Succeed',
    editGroupAuthError: 'Modify User Group permissions Failed',
    editGroupStatusSuccess: 'Modify User Group State Succeed',
    confirmEmail: 'You have sent this email and if it is sent again',
    addLowerUserSuccess: 'Add User Success',
    sendCancle: 'Cancel sending',
    sendEmailSuccess: 'Send Email Success',
    /* 表单错误提示 */
    usernameIllegality: 'Invalid username',
    passIllegality: 'Invalid password',
    emailIllegality: 'Invalid Email',
    nameIllegality: 'Invalid Name',
    iphoneIllegality: 'Invalid Iphone',
    passagainError: "Confirm password doesn't match the password",
    /* 发布消息 */
    enterMsgTitle: 'Enter Title',
    enterMsgContent: 'Enter Content',
    enterLowerUser: 'Enter Lower User',
    /* 出金申请 */
    enterCorrectMoney: 'Enter the correct amount',
    lackBalance: 'Lack of balance',
    enterCorrectComment: 'Enter the correct comment'
}

export default placeholder;




















































// WEBPACK FOOTER //
// ./src/i18n/english/placeholder.js